
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireClient?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin = false, requireClient = false }: ProtectedRouteProps) {
  const { user, isAdmin, isClient, adminLoading, clientLoading } = useAuth();

  // Wait for both admin and client checks to complete
  if (adminLoading || clientLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not logged in
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Admin-only route
  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-lock-line text-4xl text-red-600"></i>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600 mb-8">You don't have permission to access this page. This area is restricted to administrators only.</p>
          <Navigate to="/client-portal" replace />
        </div>
      </div>
    );
  }

  // Client-only route
  if (requireClient && !isClient) {
    return <Navigate to="/customer-loans" replace />;
  }

  return <>{children}</>;
}
